import React from 'react';

export const VaultCard = ({ vault }) => {
  return (
    <div className="backdrop-blur-md bg-white/10 dark:bg-white/5 border border-white/20 dark:border-white/10 rounded-2xl p-4 shadow-lg hover:shadow-2xl transition-shadow flex flex-col justify-between h-full">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full overflow-hidden border border-white/20">
          <img
            src={`https://flagcdn.com/w40/${vault.flagCode?.toLowerCase()}.png`}
            alt={`${vault.country} flag`}
            className="w-full h-full object-cover"
            onError={(e) => (e.target.style.display = 'none')}
          />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-white">{vault.vaultAlias}</h3>
          <p className="text-sm text-white/60">{vault.owner}</p>
        </div>
      </div>

      <div className="flex items-center justify-between mt-auto">
        <div>
          <span className="text-green-400 font-semibold text-xl">
            {vault.currencyCode} {vault.balance.toLocaleString()}
          </span>
        </div>
        <span className="text-xs text-white/40 uppercase tracking-wide">
          {vault.country}
        </span>
      </div>
    </div>
  );
};
